<template>
    <el-dialog :title="'下载文件'" :close-on-click-modal="false" :visible.sync="subVisible" width="700px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="100px">
            <el-row>
                <el-col :span="4">
                    <div class="majTitle1">月报名称</div>
                </el-col>
                <el-col :span="16">
                    <div class="majTitle3">{{ dataForm.monthlyName }}</div>
                </el-col>
            </el-row>
        </el-form>
        <el-row style="margin-top:20px" v-if="showEnclosureFiles != undefined && showEnclosureFiles.length > 0">
            <el-table ref="dataListTable" class="dataListTable" :data="showEnclosureFiles" header-align="center" border
                :cell-style="{ padding: '0px' }" header-cell-class-name="dataListTHeader" :show-header="false"
                style="margin-bottom: 20px;">
                <el-table-column type="index" label="NO." width="60" align="center">
                </el-table-column>
                <el-table-column prop="fileName" label="文件名称" align="center">
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="scope">
                        <el-button v-preventReClick type="text" size="small"
                            @click="downloadReport(scope.row)">查看</el-button>
                    </template>
                </el-table-column>``
            </el-table>
        </el-row>
        <el-row style="margin-top:20px;border:1px solid transparent;height:300px"  v-else>
        </el-row>
        <!-- <el-divider></el-divider> -->
    </el-dialog>
</template>

<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js"
import { Message } from 'element-ui';
export default {
    name: "monthly-file-upload",
    data() {
        return {
            addImg: addImg,
            id: "",
            subVisible: true,
            form: {},
            action: "",
            fileType: "",
            dataForm: {
                recNo: '',
                monthlyName: '',
                fileName: "",
                filePath: "",
                enclosureFiles: '',
            },
            showEnclosureFiles: [],
            dataRule: {
                monthlyName: [
                    { required: true, message: "月报名称不能为空！", trigger: "blur" }
                ],
            }
        };
    },
    components: {

    },
    activated() {

    },
    methods: {
        init(id) {
            this.dataForm = {
                recNo: '',
                monthlyName: '',
                filePath: '',
                filePathUri: '',
                fileName: '',
                enclosureFiles: [],
                monthlyKind: ''
            }
            this.showEnclosureFiles = []
            this.dataForm.recNo = id
            this.getDetail();
            this.$nextTick(() => {
                this.subVisible = true;
            })
            this.$refs['dataForm'].resetFields();
        },
        viewReportFile() {
            window.open(this.dataForm.filePathUri);
        },
        viewEncolsureFile(index) {
            window.open(this.dataForm.enclosureFiles[index].filePathUri);
        },
        downloadReport(monthlyFile) {
            // 月报系统生成的word文档，需要pdf在线预览
            if(monthlyFile.pdfShow == 1) {
                // $common.viewFile(monthlyFile.filePathUri)
                $common.viewFile(monthlyFile.filePath)
            } else {
                // 月报附件直接下载
                let filename = monthlyFile.fileName;
                if( this.dataForm.monthlyKind == '0') {
                    filename = this.getSuffix(monthlyFile.filePathUri, filename)
                }
                this.getBlob(monthlyFile.filePathUri, (blob) => {
                    this.saveAs(blob, filename)
                })
            }
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            const rLoading = this.openLoading();
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                    rLoading.close();
                } else if(xhr.status === 404){
                    rLoading.close();
                    console.log("error")
                    Message.error('文件不存在')
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },

        getDetail() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/monthlyreportinfo/info/" + this.dataForm.recNo,
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.code === 200) {
                    this.dataForm.monthlyName = data.body.monthlyName;
                    this.dataForm.filePath = data.body.filePath;
                    this.dataForm.filePathUri = data.body.filePathUri;
                    this.dataForm.fileName = data.body.fileName;
                    this.dataForm.enclosureFiles = data.body.enclosureFiles;
                    this.dataForm.monthlyKind = data.body.monthlyKind;

                    // 将月报生成文件和附件文件放在同一个list中
                    // if(data.body.fileName != null && data.body.fileName != undefined) {
                    //     let monthlyFile = {
                    //         filePath : data.body.filePath,
                    //         filePathUri : data.body.filePathUri,
                    //         fileName: data.body.fileName,
                    //         showSort: 1,
                    //         pdfShow: 1
                    //     }
                    //     this.showEnclosureFiles.push(monthlyFile)
                    // }

                    if(data.body.enclosureFiles != undefined && data.body.enclosureFiles.length > 0) {
                        for(var i = 0; i < data.body.enclosureFiles.length; i++) {
                            let enclosureFile = {
                                filePath : data.body.enclosureFiles[i].filePath,
                                filePathUri : data.body.enclosureFiles[i].filePathUri,
                                fileName: data.body.enclosureFiles[i].fileName,
                                showSort: i + 1,
                                pdfShow: 0
                            }
                             this.showEnclosureFiles.push(enclosureFile)
                        }
                   }
                }
            });
        },
    }
};
</script>

<style lang="scss" scoped="scoped">
.selItemInput.descAreaLg {
    width: 1030px !important;
}

.addImgBox {
    width: 136px;
    height: 136px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    position: relative;
}

.el-divider {
    margin: 60px 0;
    background: 0 0;
    border-top: 1px solid #E6EBF5;
}

.tmp {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 248px;
    display: inline-block;
    color: #00428e;
    margin-top: 13px;
}

.majTitle1 {
    background-color: #E1F1FF;
    padding-left: 35px;
    font-weight: bolder;
    color: #00428e !important;
    height: 38px;
    padding-top: 11px;
    border: solid #dadada 1px;
    border-right: solid #dadada 0px;
}

.majTitle3 {
    padding-left: 15px;
    font-weight: bolder;
    height: 38px;
    padding-top: 11px;
    border: solid #dadada 1px;
}
</style>
